import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";

const CardItem = ({ item, index }) => {
	const lang = useSelector((state) => state.auth.lang);
	return (
		<tr key={index} className="text-center">
			<td>{item?.client_name}</td>
			<td>{item?.client_phone}</td>
			<td>
				{item?.price} {Translate[lang].kwd}
			</td>
			<td>{item?.TrackID || ""}</td>
			<td>{item?.TranID || ""}</td>
		</tr>
	);
};
export default CardItem;
